import { useQuery } from '@tanstack/react-query';

import { profileTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';
import { Departments } from '@/types';

export const getProfiles: profileTypes.GetProfiles = (params) => {
  return axios.get(`/profiles`, { params });
};

type QueryFnType = typeof getProfiles;

type UseGetProfilesOptions = {
  department: Departments;
  config?: QueryConfig<QueryFnType>;
};

export const useGetProfiles = ({ config = {}, department }: UseGetProfilesOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['profiles', department],
    queryFn: () => getProfiles({ department }),
  });
};
